import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { QueryKeys } from '../constants/query_keys';
import { apiV1 } from '../lib/api';
import { FIVE_MINUTES_IN_MS } from '../lib/time';
import { useReferenceData } from './use_reference_data';

export const useWaterbodyTechniques = (params: {
  waterbodySlug: string;
  selectedSpeciesName: string | null;
  selectedSeasonGroupName: string | null;
}) => {
  const { waterbodySlug, selectedSpeciesName, selectedSeasonGroupName } = params;

  const { allTechniques } = useReferenceData();

  const reqParams = {
    species: selectedSpeciesName,
    season_group: selectedSeasonGroupName,
  };

  const waterbodyTechniquesQuery = useQuery({
    queryKey: QueryKeys.WATERBODIES.WATERBODY_TECHNIQUES(waterbodySlug, reqParams),
    queryFn: async () => {
      const res = await apiV1.waterbodyTechniquesFetch(waterbodySlug, reqParams);
      return res.data.data;
    },
    enabled: !!waterbodySlug && selectedSpeciesName != null,
    staleTime: FIVE_MINUTES_IN_MS,
  });
  const { data: waterbodyTechniques = [] } = waterbodyTechniquesQuery;
  const waterbodyTechniquesFull = useMemo(() => {
    return waterbodyTechniques.map((wt) => allTechniques.find((t) => t.name === wt.technique));
  }, [waterbodyTechniques]);

  return { waterbodyTechniques: waterbodyTechniquesFull };
};
